import { isSessionCompleted } from "@/react/components/Paywalls/Checkout/helpers/sessions/SessionStatusHelper";
import { isStepActionable } from "@/react/components/Paywalls/Checkout/helpers/sessions/StepStatusHelper";
import type { CheckoutSession } from "@/react/types/Paywalls/Checkout/Session";

import {
  buildMainOfferRoute,
  buildOfferRoute,
  buildCheckoutConfirmationRoute,
} from "./RoutesHelper";
import {
  getMainStep,
  getNextAvailableOfferAfterMain,
} from "./SessionStepQueryHelper";

export const canAccessConfirmation = (session: CheckoutSession): boolean =>
  isSessionCompleted(session);

export const getRedirectPath = (
  session: CheckoutSession,
  checkoutPath: string,
): string => {
  if (isSessionCompleted(session)) {
    return buildCheckoutConfirmationRoute(checkoutPath, session.id);
  }

  const mainStep = getMainStep(session.steps);
  if (mainStep && isStepActionable(mainStep)) {
    return buildMainOfferRoute(checkoutPath);
  }

  const nextActionableStep = getNextAvailableOfferAfterMain(session.steps);

  if (nextActionableStep) {
    return buildOfferRoute(checkoutPath, nextActionableStep.id);
  }

  return session.settings.community_root_url;
};
